import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "ActivityCategoryListPage" */
	'pages/sales/ActivityCategory/ActivityCategoryListPage'));

export default [{ component, exact: true, path: '/activity_categories' }];